import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  headerTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: theme.spacing(10),
    borderBottomStyle: 'solid',
    borderBottomColor: theme.accent.main,
    borderBottomWidth: 1,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    '& :nth-child(2)': { marginLeft: 'auto' },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      height: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      gap: theme.spacing(1.5),
      '& :nth-child(2)': { marginLeft: 0 },
    },
  },
  title: {
    fontSize: 23,
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  pillsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    minWidth: 0,
  },
  pillsScroll: {
    display: 'flex',
    gap: theme.spacing(1.25),
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'thin',
    minWidth: 0,
    flex: 1,
    padding: theme.spacing(0.5, 0),
  },
  addButton: {
    flexShrink: 0,
  },
}));
